import React, { createContext, useContext } from "react";

const DrawerContext = createContext();

export const DrawerProvider = ({ value, children }) => {
  return (
    <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>
  );
};

export default function useDrawer(Element) {
  return useContext(DrawerContext);
}
